const ADD_TRANSPORTERS = "ADD_TRANSPORTERS";
const ADD_TRANSPORTER = "ADD_TRANSPORTER";
const GET_TRANSPORTER = "GET_TRANSPORTER";
const CLEAN_TRANSPORTERS = "CLEAN_TRANSPORTERS";
const ADD_ACTIVE_TRANSPORTERS = "ADD_ACTIVE_TRANSPORTERS";
const TOGGLE_TRANSPORTER = "TOGGLE_TRANSPORTER";

export {
    ADD_TRANSPORTERS,
    ADD_TRANSPORTER,
    GET_TRANSPORTER,
    CLEAN_TRANSPORTERS,
    ADD_ACTIVE_TRANSPORTERS,
    TOGGLE_TRANSPORTER,
};
